import { Link } from "react-router-dom";
import { config } from "./config"
import {  getDocumentInfo } from "./utilityFunctions";

export const getDocURL = (groupId, displayName, fileName) => {
    //var groupId=2856;
    var base = config.fileDownloadUrl;
    var url = base + "/api/dlms/downloadDocument?groupId=" + groupId;

    
    return url;
}

export const getDocInfo = async (groupId) => {
    if (groupId != null && groupId != "") {
        return getDocumentInfo(groupId).then((res) => {
            console.log(res);
            var d = res.data;
            return d;
        }).catch((error) => {
            console.log("Error caught while loading data: " + error);
        });
    }
}

export const something = async() => {
    let result = await getDocInfo(2856);
    return result;
}

export const getResourceDownloadProps = (groupId) => {
    return ({
        as:Link, 
        to: getDocURL(groupId),
        target:"_blank",
        download: true
    })
}